module.exports = __webpack_public_path__ + "static/media/icon-mind.38860a04.svg";